import { Box, Button } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import React from 'react';

interface FooterProps {
    wrapperClassName?: string;
    wrapperSx?: SxProps<Theme>;
    disabled: boolean;
    onSave: () => void;
    buttonId?: string;
    buttonText?: string;
}

const Footer: React.FC<FooterProps> = ({
    wrapperClassName,
    wrapperSx,
    disabled,
    onSave,
    buttonId = 'save-channel-group-weights-button',
    buttonText = 'Save',
}) => (
    <Box className={wrapperClassName} sx={wrapperSx}>
        <Button
            id={buttonId}
            variant="contained"
            disabled={disabled}
            onClick={onSave}
        >
            {buttonText}
        </Button>
    </Box>
);

export default Footer;
